import React from 'react';
import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';

function InstagramComponent () {
    const handleClick = () => {
        const url = 'https://www.instagram.com/billygymacademia/';
        window.open(url, '_blank');
    };
    
    return (
        <IconButton onClick={handleClick}>
            <InstagramIcon sx={{color:'#ffea00'}} />
        </IconButton>
    );
};
export default InstagramComponent;